module.exports = __webpack_public_path__ + "static/media/one-book.c0a135fe.png";